module.exports = __webpack_public_path__ + "static/media/FRA Carbon Fact Sheets_1632873000753.35d46929.vtt";